export const columns = [
    {
        columnId: 1,
        name: "订单操作",
        key: "handle",
        minWidth: "80",
    },
    {
        columnId: 2,
        name: "订单编号",
        key: "id",
        minWidth: 70,
    },
    {
        columnId: 3,
        name: "用户ID",
        key: "userName",
        minWidth: 80,
    },
    {
        columnId: 4,
        name: "采购/检品工作签",
        key: "staffRemark",
        minWidth: 160,
    },
    {
        columnId: 5,
        name: "产品描述",
        key: "productDesc",
        minWidth: 160,
    },
    {
        columnId: 6,
        name: "国内物流",
        key: "trackingNumberCn",
        minWidth: 150,
    },

    // {
    //     columnId: 6,
    //     name: "国际物流",
    //     key: "trackingNumberJpn",
    //     minWidth: 150,
    // },
    {
        columnId: 7,
        name: "中国运费",
        key: "chineseFreightFee",
        minWidth: 90,
    },
    {
        columnId: 8,
        name: "单价",
        key: "price",
        minWidth: 90,
    },
    {
        columnId: 9,
        name: "用户备注",
        key: "customerRemark",
        minWidth: 160,
    },
    {
        columnId: 10,
        name: "购买订单号",
        key: "buyOrderNumber",
        minWidth: 170,
    },
    {
        columnId: 11,
        name: "购买账号",
        key: "buyAccountId",
        minWidth: 170,
    },
    {
        columnId: 12,
        name: "订单状态",
        key: "orderStatus",
        minWidth: 70,
    },
    {
        columnId: 13,
        name: "FBA/YFF/ZOZO/RSL",
        key: "isFBA",
        minWidth: 110,
    },
    {
        columnId: 14,
        name: "商品数量",
        key: "goodsCount",
        minWidth: 120,
    },
    {
        columnId: 15,
        name: "检品",
        key: "inspection",
        minWidth: 150,
    },
    {
        columnId: 16,
        name: "仓库保管",
        key: "categoryFlag",
        minWidth: 70,
    },
    {
        columnId: 17,
        name: "库位",
        key: "locatorNo",
        minWidth: 80,
    },
    {
        columnId: 18,
        name: "包装意向",
        key: "putIntent",
        minWidth: 70,
    },
    {
        columnId: 19,
        name: "商品信息",
        key: "goodsInfo",
        minWidth: 130,
    },
    {
        columnId: 20,
        name: "图片",
        key: "picture",
        minWidth: 80,
    },
    {
        columnId: 21,
        name: "不良数量",
        key: "badCount",
        minWidth: 90,
    },
/*    {
        columnId: 22,
        name: "检品视频",
        key: "playVideo",
        minWidth: "120",
    },*/
];
